import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    enable: {
        tracking: true,
    },
});
